(function () {
    'use strict';
    var controllerId = 'accredConvalida7';
    angular.module('app').controller(controllerId, ['common', '$scope', '$uibModalInstance', '_', 'datacontext', 'sectionMenu', 'accreditamento', 'isSuper', 'sedi', accredConvalida]);

    function accredConvalida(common, $scope, $uibModalInstance, _, datacontext, sectionMenu, accreditamento, isSuper, sedi) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.accreditamento = jQuery.extend({}, accreditamento);
        $scope.isSuper = isSuper;
        $scope.entities = sedi;
        $scope.days = 0;
        $scope.elencoSediAmmesse = [];

        //valore di default se ancora � da convalidare di default nella modale imposto "ammissibile"
        if ($scope.accreditamento.iConvalida == 0)
            $scope.accreditamento.iConvalida = 3;

        $scope.ok = function (isValid) {
            if (isValid) {

                var result = [];
                $scope.elencoSediAmmesse = [];
                $("input:checkbox[name=listId]:checked").each(function () {
                    var sede = {};

                    var id = $(this).val();
                    var entity = _.find($scope.entities, function (item) {
                        return item.Id == id;
                    });

                    sede.Id = id;
                    sede.bAmmessa = true;

                    $scope.elencoSediAmmesse.push(sede);
                    //result = addItem(sede);
                });

                result = updateItem($scope.accreditamento, $scope.elencoSediAmmesse);
                $uibModalInstance.close(result);

                // result = addItem($scope.accreditamento);
                //$uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.resetNote = function () {
            $scope.accreditamento.ConvalidaNote = "";
        };

        $scope.change_iConv = function () {
            switch ($scope.accreditamento.iConvalida) {
                case 2:
                    $scope.partecipazione.Asse1_7_ImportoAmmesso = 0;
                    $scope.partecipazione.Asse1_7_Qta = 0;
                    $scope.partecipazione.Asse1B_7_ImportoAmmesso = 0;
                    $scope.partecipazione.Asse1B_7_Qta = 0;
                    break;
            }
        };

        $scope.checkAll = function () {
            if ($scope.selectedAll) {
                $scope.selectedAll = true;
            } else {
                $scope.selectedAll = false;
            }
        };



        function updateItem(accreditamento, elencoSediAmmesse) {
            return datacontext.cndAccreditamento_setConvalida(accreditamento, elencoSediAmmesse).then(function (data) {

                return data;
            });
        }

    }
})();